module.exports = __webpack_public_path__ + "static/img/genesis-showroom-thumb.9f79006.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/genesis-showroom-thumb.jpg
// module id = P6NU
// module chunks = 0